// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2334a466","453":"0a6f11f2","732":"56cd5e0f","977":"4d522e1b"}[chunkId] + ".chunk.js";
};